
import Transformer from '@/transformers/transformer'
import transformPermissions from './permissions'

class GroupTransformer extends Transformer {
  static fetch ({ id, name, permissions, models_labels }) {
    return {
      id,
      name,
      permissions: transformPermissions(permissions),
      modelsLabels: models_labels
    }
  }
}

export default GroupTransformer



// WEBPACK FOOTER //
// ./src/plugins/accountPermissions/group.js